import React from 'react'
import { RelatedStories } from 'modules/brands/show/RelatedStories'
import { useCurrentBrand } from 'modules/brands/show/context/CurrentBrandProvider'
import { getShowBrandInitialProps } from 'modules/brands/show/pages/BrandShowPage'
import BrandPage from '../../../modules/brands/BrandPage'

export const BrandStoriesPage = () => {
  const { brand } = useCurrentBrand()

  if (!brand) {
    return null
  }

  return (
    <div role="tabpanel" aria-labelledby="featured">
      <RelatedStories brandId={brand.id} brandTitle={brand.title} />
    </div>
  )
}

export default BrandStoriesPage

BrandStoriesPage.getInitialProps = getShowBrandInitialProps()
BrandStoriesPage.getLayout = function getLayout(page: React.ReactElement) {
  const { props } = page
  return (
    <BrandPage meta={{ title: `${props.brand?.title} Features` }} tab="featured" params={props.params}>
      {page}
    </BrandPage>
  )
}
